import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to 'en'
    return localStorage.getItem("selectedLanguage") || "en";
  });

  useEffect(() => {
    // Save language to localStorage whenever it changes
    localStorage.setItem("selectedLanguage", language);

    // Update document direction based on language
    document.documentElement.setAttribute(
      "dir",
      language === "ar" ? "rtl" : "ltr"
    );
    document.documentElement.setAttribute("lang", language);

    // Scroll to top when language changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [language]);

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === "en" ? "ar" : "en"));
  };

  const setLanguageTo = (lang) => {
    if (lang === "en" || lang === "ar") {
      setLanguage(lang);
    }
  };

  const isArabic = language === "ar";
  const isEnglish = language === "en";

  const value = {
    language,
    setLanguage: setLanguageTo,
    toggleLanguage,
    isArabic,
    isEnglish,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
